module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.e6a9123b.eot";